import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import ProgressTimeline from '../components/ProfessorWelcome/ProgressTimeline';
import ProfileSetupSection from '../components/ProfessorWelcome/ProfileSetupSection';
import DashboardSection from '../components/ProfessorWelcome/DashboardSection';
import InfoCards from '../components/ProfessorWelcome/InfoCards';
import styles from '../components/ProfessorWelcome/ProfessorWelcome.module.css';

export default function ProfessorWelcome() {
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));
  const userId = userData?.id;

  const calculateProgress = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`, {
        headers: { Authorization: `Bearer ${userData.token}` }
      });
      const profile = res.data;
      const completed = new Set();
      let highestStep = 0;

      // Step 1: Basic Information
      const hasBasicInfo = profile.name?.trim();
      if (hasBasicInfo) {
        completed.add(0);
        highestStep = Math.max(highestStep, 1);
      }

      // Step 2: Research Interests  
      if (profile.interests?.length > 0) {
        completed.add(1);
        highestStep = Math.max(highestStep, 2);
      }

      setCompletedSteps(completed);
      setCurrentStep(highestStep);
    } catch (err) {
      console.error('Error calculating progress:', err);
    }
  };

  useEffect(() => {
    if (userData?.profileCompleted) {
      navigate('/professor-dashboard');
      return;
    }
    if (userId) {
      calculateProgress();
    }
  }, [userId, navigate]);

  const handleNavigateToProfile = () => navigate('/profile');
  const handleNavigateToDashboard = () => navigate('/professor-dashboard');

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Faculty Portal</h1>
        <p className={styles.subtitle}>
          Manage your research positions and connect with talented students
        </p>
        <ProgressTimeline currentStep={currentStep} completedSteps={completedSteps} />
      </div>

      <ProfileSetupSection 
        completedSteps={completedSteps}
        onNavigateToProfile={handleNavigateToProfile}
      />

      <DashboardSection 
        completedSteps={completedSteps}
        onNavigateToDashboard={handleNavigateToDashboard}
      />

      <InfoCards />
    </div>
  );
}